import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { getFontSize, getFontWeight } from "../../../../components/CustomText";
import CustomBoardNewLogin from "../../../../components/CustomBoardNewLogin";
import Color from "../../../../../utils/Color";
import "fontsource-muli";
import CustomOTP from "../../../../components/CustomOTP";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as selector from "../../../../../common/selectors";
import * as forgotUserIdSelector from "../../../../../common/selectors/auth";
import * as forgotUserIdAction from "../../../../../common/actions/auth";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import CustomToast from "../../../../components/CustomToast";
import AuthManager from "../../../../../utils/AuthManager";
import CustomButton from "../../../../components/CustomButton";
import Image from "../../../../../assets";
import ContactModal from '../../../OnboardingFlow/ContactPopUp';
class ForgotUserPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: "",
      height: 0,
      width: 0,
      resendOtp: false,
      otpAction: false,
      localNric: "",
      localOtpRef: "",
      localPhoneLabel: "",
      localDob: "",
      otpValues: ['', '', '', '', '', ''],
      currentFocus: 0,
      otpCountDown: 60,
      asterisks: '',
      localClientMobileLast4Digits: ''
    };
    this.inputRefs = [];
    this.timerRef = null;
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    const { verifyForgotPassOtpData } = this.props;

    await AuthManager.retrieveNric().then((value) => {
      if (value) {
        this.setState({ localNric: value });
      }
    });
    await AuthManager.retrieveDOB().then((value) => {
      if (value) {
        this.setState({ localDob: value });
      }
    });
    await AuthManager.retrieveOtpReference().then((value) => {
      if (value) {
        this.setState({ localOtpRef: value });
      }
    });
    await AuthManager.retrieveMobilePhoneLabel().then((value) => {
      if (value) {
        this.setState({ localPhoneLabel: value });
        const last4 = value.slice(-4);
        const asteriskCount = Math.max(value.length - 4, 0);
        this.setState({ localClientMobileLast4Digits: last4, asterisks: '*'.repeat(asteriskCount) });
      }
    });
    this.startTimer();
    //const { nric } = this.props.location.state;
  }

  componentDidUpdate() {
    const {
      verifyForgotPassOtpData,
      verifyForgotPassOtpStatus,
      verifyForgotPassOtpLoading,
      resendOtpData,
      forgotPasswordReqData
    } = this.props;

    if (
      verifyForgotPassOtpData === true &&
      verifyForgotPassOtpLoading === false &&
      this.state.otpAction === true
    ) {
      const { history } = this.props;
      if (this.state.resendOtp === true) {
        const otpReference = forgotUserIdSelector.verifyForgotPassOtpReference(
          forgotPasswordReqData
        );
        AuthManager.setNric(this.state.localNric);
        AuthManager.setResendOtpReference(otpReference);
        AuthManager.setResendOtp(this.state.resendOtp);
        // history.push("/prototype/EnterNewPassword", {
        //   nric,
        //   resendOtpReference,
        //   resendOtp: this.state.resendOtp,
        // });
        history.push("/EnterNewPassword");

        return;
      } else {
        AuthManager.setNric(this.state.localNric);
        AuthManager.setOtpReference(this.state.localOtpRef);
        AuthManager.setResendOtp(this.state.resendOtp);
        // history.push("/prototype/EnterNewPassword", {
        //   nric,
        //   otpReference,
        //   resendOtp: this.state.resendOtp,
        // });
        history.push("/EnterNewPassword");
      }
      this.setState({ otpAction: false });
    } else if (
      verifyForgotPassOtpData === false &&
      verifyForgotPassOtpLoading === false &&
      this.state.otpAction === true
    ) {
      this.setState({ customToastStatus: true });
      this.setState({
        toastMessage: "OTP Incorrect!",
      });
      this.setState({ otpAction: false });
    }
    // else{
    //   const { history } = this.props;
    //   history.push("/EnterNewPassword");
    // }
  }

  startTimer = () => {
    if (this.timerRef) {
      clearInterval(this.timerRef);
    }
    this.setState({ otpCountDown: 60 });
    this.timerRef = setInterval(() => {
      this.setState((prev) => {
        const newVal = prev.otpCountDown - 1;
        if (newVal <= 0) {
          clearInterval(this.timerRef);
          this.timerRef = null;
          return { otpCountDown: 0 };
        }
        return { otpCountDown: newVal };
      });
    }, 1000);
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    if (this.timerRef) clearInterval(this.timerRef);
    // AuthManager.removeNric();
    // AuthManager.removeReference();
    // AuthManager.removeMobilePhoneLabel();
  }

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight, width: window.innerWidth });
  }

  onChangeOTP = (event) => {
    this.setState({ otp: event.target.value });
  };

  onClickResend = async () => {
    //const { nric } = this.props.location.state;
    try {
      // Call reCAPTCHA API to get the token
      const recaptchaToken = await window.grecaptcha.execute(
        "6Lce7OMZAAAAALxOm9WwIETw1EL9UB73SDe4g0Tx",
        { action: "WEB_FORGOTPASSWORD" }
      );

      if (!recaptchaToken) {
        this.setState({
          //toastMessage: "User ID and Password can not be empty.",
          customToastStatus: true,
          toastMessage: "Unable to verify reCAPTCHA. Please try again.",
        });
        return;
      }

      this.setState({ resendOtp: true });
      const { forgotPasswordRequest } = this.props;
      forgotPasswordRequest(this.state.localNric, this.state.localDob, recaptchaToken);


    } catch (error) {
      this.setState({
        //toastMessage: "User ID and Password can not be empty.",
        customToastStatus: true,
        toastMessage: "Error during reCAPTCHA verification. Please try again.",
      });
    }

    // this.setState({ resendOtp: true });
    // const { forgotPasswordRequest } = this.props;
    // forgotPasswordRequest(this.state.localNric,this.state.localDob);
  };

  handleInputChange = (index, value) => {
    const digit = value.replace(/\D/g, '').slice(-1);
    const otpValues = [...this.state.otpValues];
    otpValues[index] = digit;
    this.setState({ otpValues });
    if (digit && index < otpValues.length - 1) {
      this.setState({ currentFocus: index + 1 }, () => {
        const ref = this.inputRefs[this.state.currentFocus];
        if (ref) ref.focus();
      });
    }
  };

  handleKeyDown = (index, event) => {
    if (event.key === 'Backspace') {
      event.preventDefault();
      const otpValues = [...this.state.otpValues];
      if (!otpValues[index] && index > 0) {
        this.setState({ currentFocus: index - 1 }, () => {
          const ref = this.inputRefs[this.state.currentFocus];
          if (ref) ref.focus();
        });
      } else {
        otpValues[index] = '';
        this.setState({ otpValues });
      }
    }
  };

  onClickVerify = () => {
    const { verifyForgotPassOtpRequest, forgotPasswordReqData, resendOtpData } = this.props;
    const code = this.state.otpValues.join('');
    if (!code) {
      this.setState({ customToastStatus: true, toastMessage: 'Please enter your OTP.' });
      return;
    }
    const resendOtpReference = forgotUserIdSelector.getResendOtpReference(resendOtpData);
    const otpReference = forgotUserIdSelector.verifyForgotPassOtpReference(forgotPasswordReqData);

    if (this.state.resendOtp) {
      verifyForgotPassOtpRequest(code, otpReference);
    } else {
      verifyForgotPassOtpRequest(code, this.state.localOtpRef);
    }
    this.setState({ otpAction: true });
  };

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatus: false });
  };

  onClickBack = () => {
    window.history.back();
  };

  handleKeypress = (event) => {
    //it triggers by pressing the enter key
    if (event.keyCode === 13) {
      this.onClickVerify();
    }
  };

  handleOpen = () => {
    this.setState({ visibleContactPopUp: true })
  }

  handleClose = () => {
    this.setState({ visibleContactPopUp: false })
  }

  renderChildren = () => {
    const { otpValues, otpCountDown, asterisks, localClientMobileLast4Digits } = this.state;
    return (
      <div className={this.props.classes.container}>
        <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'center' }}><img src={Image.otpIcon} /></div>
        <div className={this.props.classes.headerTextStyle}>We’ve sent an OTP code to</div>
        <div className={this.props.classes.subHeaderText}>{`****${localClientMobileLast4Digits}`}</div>
        <div className={this.props.classes.otpContainer}>
          {otpValues.map((val, index) => (
            <input
              key={index}
              ref={el => this.inputRefs[index] = el}
              type="text"
              maxLength={1}
              value={val}
              onChange={e => this.handleInputChange(index, e.target.value)}
              onKeyDown={e => this.handleKeyDown(index, e)}
              inputMode="numeric"
              className={this.props.classes.otpInput}
            />
          ))}
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
          <span className={this.props.classes.resendTextV1}>Didn’t receive the OTP? </span>
          <span className={this.props.classes.resendText} onClick={otpCountDown < 1 ? this.onClickResend : null}>{otpCountDown > 0 ? `Resend in ${otpCountDown} sec` : 'Resend OTP'}</span>
        </div>
        <div style={{ marginTop: '2.5rem' }}>
          <CustomButton title="Verify" onClick={this.onClickVerify} design={this.props.classes.buttonStyle} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '2.5rem' }}>
          <span style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 1)', fontWeight: 'bold' }}>Mobile No. incorrect?</span>
          <span style={{ fontSize: '16px', color: 'rgba(14, 165, 233, 1)', fontWeight: 'bold', marginLeft: '0.4rem', cursor: 'pointer' }} onClick={this.handleOpen}>Contact Us</span>
        </div>
      </div>
    );
  };

  render() {
    const {
      classes,
      resendOtpLoading,
      verifyForgotPassOtpLoading,
      forgotPasswordReqLoading,
    } = this.props;
    const { height } = this.state;
    const { width } = this.state;
    return (
      <>
        <CustomBoardNewLogin
          children={this.renderChildren()}
          height={height}
          width={width}
          isFixWidth={true} />
        <CustomToast
          open={this.state.customToastStatus}
          handleCloseCustomToast={this.handleCloseCustomToast}
          title={this.state.toastMessage}
          warning
        />
        {verifyForgotPassOtpLoading ? <LoadingOverlay loading={true} /> : false}
        {resendOtpLoading ? <LoadingOverlay loading={true} /> : false}
        {forgotPasswordReqLoading ? <LoadingOverlay loading={true} /> : false}
        <ContactModal isVisible={this.state.visibleContactPopUp} onClose={this.handleClose} />
      </>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  headerTextStyle: {
    fontWeight: 700,
    fontSize: 20,
    color: "#333333",
    [theme.breakpoints.down('sm')]: {
      // Slightly smaller on mobile
      fontSize: 18,
    },
    marginTop: 20,
    marginLeft: '0.2rem'
  },
  labelTextInputTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("large"),
    color: Color.primaryTextColor,
  },
  textInputContainer: {
    height: 40,
  },
  inputContainer: {
    marginTop: 40,
  },
  buttonStyle: {
    height: '48px',
    [theme.breakpoints.down('sm')]: {
      height: '45px',
    },
    [theme.breakpoints.up("lg")]: {
      minWidth: 496,
      maxWidth: 496,
      left: '-3.4rem',
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: 410,
      maxWidth: 410,
      // left: '-3.4rem',
    },
   
    [theme.breakpoints.down('xs')]: {
      minWidth: '100%',
      maxWidth: '100%',
      left: 0,
    }
  },
  container: {
    paddingTop:'3.5rem',
    paddingLeft:'2.2rem',
    paddingRight:'2.2rem',
    [theme.breakpoints.down('sm')]:{
      paddingTop:'0rem',
      paddingLeft:'1rem',
      paddingRight:'1rem',
      paddingBottom:'2rem'
    }
  },
  subHeaderText: {
    fontWeight: 500,
    fontSize: 14,
    color: '#333333',
    marginTop: '0.6rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
    marginLeft: '0.2rem'
  },
  otpContainer: {
    display:'flex',gap:'13px',justifyContent:'center',marginTop:'1.5rem',marginLeft:'2.5rem',
    [theme.breakpoints.down('xs')]:{
      flexWrap:'wrap',
      gap:'11px',
      marginLeft:0,
    },
  },
  otpInput: {
    textAlign: 'center',
    fontSize: '16px',
    width: '48px',
    height: '58px',
    border: '1px solid #C6C7C9',
    [theme.breakpoints.down('xs')]: {
      // Slightly shrink on very small screens
      width: '37px',
      height: '50px',
    },
    borderRadius: '8px',
    '&:focus': {
      outline: 'none',
      border: '2px solid #0EA5E9'
    }
  },
  resendText: {
    color: '#0D99FF',
    // textDecoration: 'underline',
    fontSize: '12px',
    cursor: 'pointer',
    marginTop: '1rem',
    fontWeight: 500,
    marginLeft: '0.3rem'
  },
  resendTextV1: {
    color: 'rgba(112, 112, 112, 1)',
    fontSize: '12px',
    cursor: 'pointer',
    marginTop: '1rem',
    fontWeight: 500,
  },
});

function mapStateToProps(state) {
  return {
    verifyForgotPassOtpData: selector.verifyForgotPassOtpData(state),
    verifyForgotPassOtpLoading: selector.verifyForgotPassOtpLoading(state),
    verifyForgotPassOtpStatus: selector.verifyForgotPassOtpStatus(state),
    resendOtpData: selector.resendOtpData(state),
    resendOtpLoading: selector.resendOtpLoading(state),
    resendOtpStatus: selector.resendOtpStatus(state),
    forgotPasswordReqData: selector.forgotPasswordReqData(state),
    forgotPasswordReqLoading: selector.forgotPasswordReqLoading(state),
    forgotPasswordReqStatus: selector.forgotPasswordReqStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    verifyForgotPassOtpRequest: (code2Fa, otpReference) =>
      dispatch(
        forgotUserIdAction.verifyForgotPassOtpRequest(code2Fa, otpReference)
      ),
    resendOtpRequest: (userID) =>
      dispatch(forgotUserIdAction.resendOtpRequest(userID)),
    forgotPasswordRequest: (userID, birthdate, recaptchaToken) =>
      dispatch(forgotUserIdAction.forgotPasswordRequest(userID, birthdate, recaptchaToken)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(ForgotUserPassword)));
